import Dispatcher from '../Dispatcher';
import OverlayActionTypes from './OverlayActionTypes';
import NotificationTypes from '../../modules/NotificationTypes';

let _r360 = null;
let nextNotificationId = 0;

const Actions = {
    selectGroup(id) {
        if (_r360) {
            _r360.runtime.context.callFunction('RCTDeviceEventEmitter', 'emit', [
                'tourActions.selectGroup',
                id,
            ]);
        }
    },
    selectSphere(id, method) {
        if (_r360) {
            _r360.runtime.context.callFunction('RCTDeviceEventEmitter', 'emit', [
                'tourActions.selectSphere',
                id,
                method,
            ]);
        }
    },
    showLoadingOverlay(showLoadingOverlay) {
        Dispatcher.dispatch({
            type: OverlayActionTypes.SHOW_LOADING_OVERLAY,
            showLoadingOverlay,
        });
    },
    showOnboardingGuide(showOnboardingGuide) {
        Dispatcher.dispatch({
            type: OverlayActionTypes.SHOW_ONBOARDING_GUIDE,
            showOnboardingGuide,
        });
    },
    viewOnboardingPage(pageIndex) {
        Dispatcher.dispatch({
            type: OverlayActionTypes.VIEW_ONBOARDING_PAGE,
            pageIndex,
        });
    },
    scheduleLoadingOverlay(showLoadingOverlay, delay = 1500) {
        let loadingOverlayTimeout = setTimeout(() => {
            Actions.showLoadingOverlay(showLoadingOverlay);
        }, delay);
        Dispatcher.dispatch({
            type: OverlayActionTypes.SCHEDULE_LOADING_OVERLAY,
            loadingOverlayTimeout,
        });
    },
    addNotification(
        titleTranslationKey: string,
        messageTranslationKey: string,
        actions?: Array<Object>
    ) {
        Dispatcher.dispatch({
            type: OverlayActionTypes.ADD_NOTIFICATION,
            notificationType: NotificationTypes.warning,
            messageTranslationKey,
            titleTranslationKey,
            id: `${nextNotificationId++}`,
            actions,
        });
    },
    removeNotifications(ids: Array<string>) {
        Dispatcher.dispatch({
            type: OverlayActionTypes.REMOVE_NOTIFICATIONS,
            ids,
        });
    },
    clearNotifications() {
        Dispatcher.dispatch({
            type: OverlayActionTypes.CLEAR_NOTIFICATIONS,
        });
    },
    setContext(rnctx) {
        _r360 = rnctx;
        Dispatcher.dispatch({
            type: OverlayActionTypes.SET_R360_CONTEXT,
            viewport: rnctx._parent,
            r360: rnctx,
        });
    },
};

export default Actions;
